var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg4 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 101",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "4")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4",
    "data-name": "Capa 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M50,0A34.52,34.52,0,0,0,32.08,64l1,25.51a6.23,6.23,0,0,0,5.22,5.83C39.38,98.58,44.21,101,50,101s10.55-2.39,11.66-5.57a6.2,6.2,0,0,0,5.84-5.92l.88-25.79A34.51,34.51,0,0,0,50,0ZM61.88,90.79a.14.14,0,0,1-.12.1H38.88c-.06,0-.14-.08-.14-.08v-.17L62,86.15Zm.23-6.89L38.66,88.42l-.12-3.22,23.68-4.56Zm.18-5.51L38.45,83l-.12-3.22,24.07-4.64Zm5.63-40.25L57.52,56.78l-.59,15.71h5.56v.4L38.24,77.55,38,72.48h5l-.59-15.71L32.08,38.14a1.22,1.22,0,0,1,.21-1.44,1.27,1.27,0,0,1,.24-.21l0,0h0a1.19,1.19,0,0,1,.64-.2H66.49a1.17,1.17,0,0,1,.34.07,1.2,1.2,0,0,1,.6.14A1.23,1.23,0,0,1,67.91,38.14Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg4, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/4.deb01c15.svg";
export { ForwardRef as ReactComponent };